import React, { useEffect, useState } from 'react';
import { ChartContent } from './ChartContent';
import { LineGraph } from './LineGraph';
import { colors } from '../../../../theme/palette';
import { QRCodeScanData } from '../../../../store/models/analytics/QRCodeScans';

export interface ScanByDateProps {
	data: QRCodeScanData[];
}

export const ScanByDate = (props: ScanByDateProps) => {
	const { data } = { ...props };
	const [selected, setSelected] = useState('');
	const [scans, setScans] = useState([]);
	const [total, setTotal] = useState(0);
	const [qrCodeNames, setQrCodeNames] = useState({});

	useEffect(() => {
		// if qrCodeNames object isnt populated yet, but the data object is, then populate qrCodeNames
		if (!Object.keys(qrCodeNames).length && data.length) {
			const tempQrCodeNames = {};
			data.forEach((qrCode) => {
				// Display "Default QR Code" for better UX when name is "default"
				const displayName = qrCode.qrCodeName === 'default' ? 'Default QR Code' : qrCode.qrCodeName;
				tempQrCodeNames[qrCode.qrCodeId] = displayName;
			});
			setQrCodeNames(tempQrCodeNames);
			// Set the first QR code as selected if none is selected
			if (!selected && data.length > 0) {
				setSelected(data[0].qrCodeId);
			}
		}
	}, [data, qrCodeNames, selected]);

	useEffect(() => {
		// if qrCodeNames object is populated, then set the scans and total
		if (Object.keys(qrCodeNames).length > 0 && selected) {
			const selectedQrCode = data.find((qrCode) => qrCode.qrCodeId === selected);
			if (selectedQrCode) {
				setScans(selectedQrCode.scans);
				const tempTotal = selectedQrCode.scans?.reduce((acc, scan) => acc + scan.value, 0) || 0;
				setTotal(tempTotal);
			} else {
				// If no data for selected QR code, set empty values
				setScans([]);
				setTotal(0);
			}
		}
	}, [selected, data, qrCodeNames]);

	return (
		<ChartContent
			name={'SCAN BY DATE'}
			selected={selected}
			pageNames={qrCodeNames}
			setSelected={setSelected}
			total={total}
			toolTipMsg={
				'The number of scans for the selected QR code. Change QR codes using the QR code selector in the top right of the Scan By Date card.'
			}
			clickStats={true}
			totalLabel={'Total Scans: '}
		>
			<LineGraph width="100%" height={230} data={scans} name="Scans" color={colors.tealAccent} />
		</ChartContent>
	);
};
